/**
 * Splits options into the selected ones and the rest, preserving input order within each half.
 *
 * Pass the selection a picker *opened with* (see `useOpenSnapshot`), not the live one: keying the
 * split on live state is what makes a ticked row jump out of its group mid-click.
 *
 * @param items - The options to split.
 * @param getKey - Reads an option's identity; callers key on different fields.
 * @param selectedKeys - Keys counting as selected. Keys matching no item are ignored.
 * @returns New arrays; the input is never mutated.
 */
export function partitionSelected<T>(
  items: readonly T[],
  getKey: (item: T) => string,
  selectedKeys: ReadonlySet<string>,
): { selected: T[]; unselected: T[] } {
  const selected: T[] = [];
  const unselected: T[] = [];

  for (const item of items) {
    if (selectedKeys.has(getKey(item))) {
      selected.push(item);
    } else {
      unselected.push(item);
    }
  }

  return { selected, unselected };
}
